//////////////////////////////////////////////////////////////////////////////////////////////////////////
// paypal payment with credit logs modal (this modal shows when user clicks a device with high balance) //
//////////////////////////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutActions } from '../store';
import { getIsAdmin } from '../common/selectors';

import {
  TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, Typography, Box, Modal, Snackbar, IconButton, Button
} from '@material-ui/core';
import Pagination from '../components/pagination'

import { useEffectAsync } from '../reactHelper';

import VisibilityOffIcon from '@material-ui/icons/Close';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { Stack } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import moment from 'moment';
import { api_call, console_log, curl_post, empty, getLocalTimezone, getToken, get_utc_timestamp_ms } from '../helpers/untils';
import { API_BASE_URL, APP_NAME, DEVICE_PAYMENT_STATUS, DEVICE_TYPE } from '../config/constant';
import PayPalBtn from '../components/PayPalBtn';
import { setSettingPersist } from '../helpers/misc';
import EscrowLogsModal from './EscrowLogsModal';
import CreditCardSelectModal from './CreditCardSelectModal';
import ConfirmDialog from '../components/ConfirmDialog';

const itemType = "credit"

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '1024px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};

const modalInnerStyle = {
  position: 'relative',
  width: '100%',
  maxHeight: 'calc(100vh - 160px)',
  overflowY: 'auto'
};

const useStyles = makeStyles((theme) => ({
  paypalBtnBox: {
    position: 'relative',
    display: 'block',
  },
  paypalHideBtn: {
    right: 0,
    cursor: 'pointer',
    paddingLeft: '6px',
    paddingRight: '6px',
    paddingTop: '4px',
    paddingBottom: '10px',
    marginLeft: '2px',
  },
  optionsRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
}));

const CreditLogsTable = (props) => {
  const { selectedDevice, setDevice, updateTimestamp, setUpdateTimestamp, paypalSubscriptionDetail, setPaypalSubscriptionDetail, logItems, setLogItems, escrowUser, setEscrowUser } = props;

  const user = useSelector((state) => state.session.user);
  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTableData, setCurrentTableData] = useState([]);
  const PageSize = 5;

  useEffect(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    setCurrentTableData(logItems.slice(firstPageIndex, lastPageIndex))
  }, [currentPage]);

  useEffectAsync(async () => {
    var url = `/api/creditLogsByDeviceId/` + selectedDevice['id'];
    const response = await api_call(url);
    let t_items = []
    if (response.ok) {
      const creditLogsApiRes = await response.json()
      console_log("creditLogsApiRes::::", creditLogsApiRes)
      t_items = creditLogsApiRes['log_list']
      setItems(t_items);

      const device = creditLogsApiRes['device']
      if (device) {
        setDevice(device)
      }

      const escrow_user = creditLogsApiRes['escrow_user']
      if (!empty(escrow_user)) {
        setEscrowUser(escrow_user)
      } else {
        setEscrowUser({})
      }
    }
    setLogItems(t_items)
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    setCurrentTableData(t_items.slice(firstPageIndex, lastPageIndex));
  }, [updateTimestamp]);

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Amount</TableCell>
              <TableCell>Added by</TableCell>
              <TableCell>Note</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Serial Number</TableCell>
              <TableCell>Balance</TableCell>
              <TableCell>When</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              (currentTableData.length > 0) ? (
                currentTableData.map((item) =>
                  <TableRow key={item.id}>
                    <TableCell>{item.amount}</TableCell>
                    <TableCell>{item.from_name ?? 'Owner'}</TableCell>
                    <TableCell>{item.note}</TableCell>
                    <TableCell>{item.to_name}</TableCell>
                    <TableCell>{item.device_serial_number}</TableCell>
                    <TableCell>{item.to_balance}</TableCell>
                    <TableCell>{moment(item.createdAt).format('LLL')}</TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow key={`no-data`}>
                  <TableCell colSpan={7} align="center">No log data</TableCell>
                </TableRow>
              )
            }

          </TableBody>
        </Table>
        <div style={{ marginTop: '5px' }}></div>
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageSize={PageSize}
          totalCount={logItems.length}
          onPageChange={page => setCurrentPage(page)}

        />
      </TableContainer>
    </>
  )
}

const PaypalPaymentBox = (props) => {
  const { open, setOpen, item, setItem, plan_id = "", updateTimestamp, setUpdateTimestamp } = props;
  const dispatch = useDispatch();

  const user = useSelector((state) => state.session.user);

  const paypalSubscribe = (data, actions) => {
    console.log("data, actions:::", data, actions)
    return actions.subscription.create({
      'plan_id': plan_id,
      'custom_id': `${user['id']}_${item['id']}_${itemType}`
    });
  };

  const paypalOnError = (err) => {
    console.log("Error")
  }

  const paypalOnApprove = (data, actions) => {
    console_log("Payapl approved:::data, actions", data, actions)
    // Capture the funds from the transaction
    return actions.subscription.get().then(function (details) {
      // Show a success message to your buyer
      console_log("Subscription completed", details);
      submitSubscription(data)
    });
  }

  const submitSubscription = async (data) => {
    let url = "/api/payment/paypal/subscription-complete"
    let postData = {
      userId: user['id'],
      plan_id: plan_id,
      orderID: data.orderID,
      subscriptionID: data.subscriptionID,
      itemId: item['id'],
      itemType: itemType
    }

    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData),
    });
    if (response.ok) {
      let payalResponse = await response.json()
      let newBalance = payalResponse['to_balance']
      if (itemType === 'credit') {
        setItem({ ...item, credit: newBalance })
      }
      else if (itemType === 'escrow') {
        setItem({ ...item, escrow_balance: newBalance })
      }
      setOpen(false);
      dispatch(layoutActions.setDeviceReloadTimestamp({ value: get_utc_timestamp_ms() }));

      if (item['deviceType'] === DEVICE_TYPE.SMARTCAR) {
        goSmartcarAuthPage()
      }
      return payalResponse;
    } else {
      alert("Paypal subscription error")
    }
  }

  const goSmartcarAuthPage = async () => {
    const response = await api_call(`/api/smartcar/get-login-url`);
    if (response.ok) {
      const res = await response.json()
      console_log("smartcar res:::", res)
      setSettingPersist('smartcar_auth_source', 'device')
      window.location.href = res.link
      //history.push('/smartcar-device')
    } else {
      alert("Smartcar authentication error")
    }
  }

  const getPaypalPaymentAmount = () => {
    const defaultAmount = 15
    let amount = defaultAmount
    if (item && item.monthly_cost && Number(item.monthly_cost) > 0) {
      amount = Number(item.monthly_cost)
    }
    const amountDecimal = amount.toFixed(2)
    return amountDecimal
  }

  return (
    <>
      <div className='text-center' style={{ marginTop: '1rem', marginRight: '1rem', width: '500px', maxWidth: 'calc(100vw - 160px)' }}>
        <PayPalBtn
          amount={getPaypalPaymentAmount()}
          currency="USD"
          createSubscription={paypalSubscribe}
          onApprove={paypalOnApprove}
          catchError={paypalOnError}
          onError={paypalOnError}
          onCancel={paypalOnError}
        />
      </div>
    </>
  );
}

const PaypalCreditLogsModal = (props) => {
  // show paypal buttons and credit logs
  const dispatch = useDispatch();
  const classes = useStyles();

  const user = useSelector((state) => state.session.user);
  const isAdmin = useSelector(getIsAdmin);

  const { open, setOpen, item, setItem, chargeRequiredNum } = props;
  const [updateTimestamp, setUpdateTimestamp] = useState(0)
  const [logItems, setLogItems] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [billingSource, setBillingSource] = useState(item?.billing_source);

  const [disableCloseBtn, setDisableCloseBtn] = useState(true)

  useEffect(() => {
    setBillingSource(item?.billing_source)
  }, [item?.id]);

  useEffect(() => {
    if (item && item.id) {
      loadPlanId();
    }
  }, [item?.id]);

  useEffect(() => {
    setDisableCloseBtn(chargeRequiredNum !== DEVICE_PAYMENT_STATUS.PAYMENT_REMINDER)
  }, [chargeRequiredNum])

  useEffect(() => {
    console.log("chargeRequiredNum:::::", chargeRequiredNum, open)
  }, [open, chargeRequiredNum])

  useEffect(() => {
    if (open) {
      resolveSelectedCardLast4();
    }
  }, [open, item?.stripe_payment_method_id])

  const handleCreditModalClose = () => {
    setOpen(false)
  }

  ////////////////////////////////////paypal subscription modal///////////////////////////////////////////
  const [planId, setPlanId] = useState("");
  const [paypalAccessToken, setPaypalAccessToken] = useState("");
  const [paypalSubscriptionDetail, setPaypalSubscriptionDetail] = useState(null);

  const loadPlanId = async () => {
    let planInfo = await getMoovetraxMonthlyPlan()
    console_log("PlanInfo:::", planInfo)
    if (!empty(planInfo)) {
      setPlanId(planInfo['id'])
    }
  }
  const getMoovetraxMonthlyPlan = async () => {
    let planInfo = await createMoovetraxMonthlyPlan();
    return planInfo;
  }
  const createMoovetraxMonthlyPlan = async () => {
    let url = "/api/payment/paypal/create-plan"
    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ itemId: item.id, itemType: itemType }),
    });

    if (response.ok) {
      let payalResponse = await response.json()
      if (payalResponse['id']) {
        setItem({ ...item, plan_id: payalResponse['id'] })
      }
      return payalResponse;
    }
    return false;
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const onClosePaypalPopup = async (deviceId) => {
    let url = "/api/devices/close-paypal-banner"
    let postData = {
      deviceId: deviceId
    }

    let response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(postData),
    });

    return true
  }

  const onClickCloseSubscriptionBanner = () => {
    console_log(`onClickCloseSubscriptionBanner:::`, item)
    //await onClosePaypalPopup(item.id)
    handleCreditModalClose()
  }

  //////////////////////////////////////////////////////////////////////////////////////////////
  const [confirmAction, setConfirmAction] = useState('')
  const [confirmText, setConfirmText] = useState(`Escrow In Use - Device Paypal Suspended`)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [pendingPaymentMethodId, setPendingPaymentMethodId] = useState(null)
  const onClickAgreeConfirm = () => {
    if (confirmAction === 'createStripeSubscription') {
      setShowConfirmModal(false)
      const pmId = pendingPaymentMethodId
      setPendingPaymentMethodId(null)
      createStripeSubscription(pmId)
      return
    }
    saveBillingSource()
  }
  const onClickCancelConfirm = () => {
    setShowConfirmModal(false)
    if (confirmAction === 'createStripeSubscription') {
      setPendingPaymentMethodId(null)
      setBillingSource(item?.billing_source)
      return
    }
    if (billingSource === 'escrow') {
      setBillingSource('paypal')
    }
  }
  const onClickSaveBillingSource = (billing_source) => {
    setBillingSource(billing_source)
    if (billing_source === 'credit_card') {
      setCardSelectModalOpen(true)
      return false
    }
    saveBillingSource(billing_source)
  }

  ///////////////////////// credit card select modal /////////////////////////
  const [cardSelectModalOpen, setCardSelectModalOpen] = useState(false);
  const [selectedCardLast4, setSelectedCardLast4] = useState(null);
  const resolveSelectedCardLast4 = async () => {
    const pmId = item?.stripe_payment_method_id
    if (!pmId) {
      setSelectedCardLast4(null)
      return
    }
    const response = await api_call('/api/payment/stripe/cards')
    if (response.ok) {
      const res = await response.json()
      const card = (res.cards || []).find((c) => c.id === pmId)
      setSelectedCardLast4(card ? card.last4 : null)
    }
  }
  const onSelectCreditCard = (card) => {
    setSelectedCardLast4(card.last4)
    createStripeSubscription(card.id)
  }
  const onClickPayCredit = (e) => {
    e.stopPropagation()
    const pmId = item?.stripe_payment_method_id
    if (!pmId) {
      setToastMessage('Please select a card first')
      setSnackbarOpen(true)
      return
    }
    createStripeSubscription(pmId)
  }
  const onClickCancelCardSubscription = async (e) => {
    e.stopPropagation()
    if (apiLoading) {
      return false
    }
    if (!window.confirm("Are you sure you want to cancel subscription?")) {
      return false
    }
    const url = `/api/payment/stripe/device/cancel-subscription`
    const post_data = { device_id: item.id }
    setApiLoading(true)
    const response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post_data),
    })
    setApiLoading(false)
    if (response.ok) {
      const responseObj = await response.json()
      setItem(responseObj)
      setSelectedCardLast4(null)
      setToastMessage(`Subscription cancelled`)
      setSnackbarOpen(true)
      dispatch(layoutActions.setDeviceReloadTimestamp({ value: get_utc_timestamp_ms() }));
      setUpdateTimestamp(get_utc_timestamp_ms())
    } else {
      const errorObj = response
      const errorMessage = errorObj.error ?? errorObj.message ?? 'Failed to cancel subscription'
      alert(errorMessage)
    }
  }
  const onCancelCreditCardSelect = () => {
    setBillingSource(item?.billing_source)
  }
  const createStripeSubscription = async (paymentMethodId) => {
    if (apiLoading) {
      return false
    }
    var url = `/api/payment/stripe/create-subscription`
    const post_data = {
      device_id: item.id,
      payment_method_id: paymentMethodId,
      itemType: itemType,
    }
    setApiLoading(true)
    const response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post_data),
    });
    setApiLoading(false)
    if (response.ok) {
      const responseObj = await response.json()
      setItem(responseObj)
      setToastMessage(`Stripe subscription created successfully`)
      setSnackbarOpen(true)
      dispatch(layoutActions.setDeviceReloadTimestamp({ value: get_utc_timestamp_ms() }));
      setUpdateTimestamp(get_utc_timestamp_ms())
      setDisableCloseBtn(false);
    } else {
      const errorObj = response
      const errorMessage = errorObj.error ?? errorObj.message ?? 'Failed to create subscription'
      alert(errorMessage)
      setBillingSource(item?.billing_source)
    }
  }
  const saveBillingSource = async (billing_source = null) => {
    if (apiLoading) {
      return false
    }
    if (empty(billing_source)) {
      billing_source = billingSource
    }
    var url = `/api/devices/set-billing-source`
    const post_data = {
      device_id: item.id,
      billing_source: billing_source
    }
    setApiLoading(true)
    const response = await api_call(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(post_data),
    });
    setApiLoading(false)
    if (response.ok) {
      let responseObj = await response.json()
      setItem(responseObj)
      dispatch(layoutActions.setDeviceReloadTimestamp({ value: get_utc_timestamp_ms() }));
      setUpdateTimestamp(get_utc_timestamp_ms())
      if (billing_source === 'escrow') {
        setOpen(false)
      }
    } else {
      let errorObj = response
      if (errorObj['error']) {
        alert(errorObj['error'])
        setBillingSource(item?.billing_source)
        if (errorObj['escrow_balance_insufficient']) {
          setOpen(false)
          showEscrowLogsModal()
        }
      } else {
        alert("Unknown error")
      }
    }
    setShowConfirmModal(false)
  }

  const [escrowUser, setEscrowUser] = useState();
  const [escrowLogsModalOpen, setEscrowLogsModalOpen] = useState(false);
  const showEscrowLogsModal = async () => {
    setItem(escrowUser)
    setEscrowLogsModalOpen(true)
  }

  const OnClickEscrowBalance = (event) => {
    event.preventDefault()
    setOpen(false)
    showEscrowLogsModal()
  }

  const onClickShowVideo = () => {
    dispatch(layoutActions.showPaymentVideoModal());
  }

  const onClickCreditCard = () => {
    if (!user.administrator) {
      setCardSelectModalOpen(true);
    }
  }

  //////////////////////// app modal close feature //////////////////////////////////////////
  // const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  // useEffect(() => {
  //   if (appModalCloseTimestamp) {
  //     setOpen(false)
  //   }
  // }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  const onClickDownloadExcel = () => {
    const token = getToken()
    const deviceId = item.id
    const timezone = getLocalTimezone()
    const payload = {
      deviceId: deviceId,
      timezone: timezone
    }
    console.log(`onClickDownloadExcel payload:::`, payload)
    const urlExport = API_BASE_URL + "/api/creditLogs/download";
    const exportFileName = `credit_logs(${item?.name}).xlsx`
    curl_post(urlExport, { ...payload, exportFileName }, 'post', "", true, token); //window.location.href = exportUrl
  }

  return (
    <>
      <Modal
        open={open}
        // onClose={handleCreditModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        disableEnforceFocus
      >
        <Box sx={modalStyle}>
          <Box sx={modalInnerStyle}>
            <Snackbar
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              open={snackbarOpen}
              onClose={() => { setSnackbarOpen(false) }}
              autoHideDuration={1500}
              message={toastMessage}
            />
            <div className={classes.paypalBtnBox}>
              {
                ((planId) && !empty(planId)) ? (
                  <>
                    {/* {
                      (parseFloat(item.credit) > MAX_CREDIT_AMOUNT) ? (
                        <div></div>
                      ) : (
                        <div style={{ textAlign: 'right', position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
                          <span onClick={() => onClickCloseSubscriptionBanner()} className={classes.paypalHideBtn} ><VisibilityOffIcon color="action" /></span>
                        </div>
                      )
                    } */}
                    {
                      (disableCloseBtn) ? (
                        <div></div>
                      ) : (
                        <div style={{ textAlign: 'right', position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
                          <span onClick={() => onClickCloseSubscriptionBanner()} className={classes.paypalHideBtn} ><VisibilityOffIcon color="action" /></span>
                        </div>
                      )
                    }
                    <div className={classes.optionsRow}>
                      <Box sx={{ mr: 1 }}>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={(billingSource === 'credit_card' && !item?.stripe_payment_method_id) ? '' : (billingSource || '')}
                            onChange={(event) => onClickSaveBillingSource(event.target.value)}
                            style={{ justifyContent: "flex-start" }}
                          >
                            <FormControlLabel value="credit_card" control={<Radio />} label={
                              <Box sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }} onClick={() => onClickCreditCard()}>
                                <CreditCardIcon style={{ fontSize: '26px', color: '#374151' }} />
                                {selectedCardLast4 ? <span style={{ color: '#6b7280' }}>{`•••• ${selectedCardLast4}`}</span> : <span>Credit Card</span>}
                                {(selectedCardLast4 && Number(item?.credit) > 0) ? (
                                  <Button color="primary" variant="contained" size="small" onClick={onClickPayCredit} disabled={apiLoading} style={{ marginLeft: '8px', height: '32px' }}>
                                    Pay
                                  </Button>
                                ) : null}
                                {selectedCardLast4 ? (
                                  <Button color="primary" variant="outlined" size="small" onClick={onClickCancelCardSubscription} disabled={apiLoading} style={{ marginLeft: '8px', height: '32px' }}>
                                    Cancel
                                  </Button>
                                ) : null}
                              </Box>
                            } />
                            <FormControlLabel value="paypal" control={<Radio />} label={
                              <>
                                <PaypalPaymentBox
                                  open={open}
                                  setOpen={setOpen}
                                  item={item}
                                  setItem={setItem}
                                  plan_id={planId}
                                  updateTimestamp={updateTimestamp}
                                  setUpdateTimestamp={setUpdateTimestamp}
                                />
                              </>
                            } />
                            <FormControlLabel value="escrow" control={<Radio />} label={
                              <Box sx={{ textAlign: 'center' }}>
                                <Box>
                                  Pay from Escrow {escrowUser?.id ? <span style={{ cursor: 'pointer', color: '#1366ff' }} onClick={(e) => OnClickEscrowBalance(e)}>({escrowUser?.escrow_balance})</span> : <></>}
                                </Box>
                                {/* <Box>
                                <Button color="primary" variant="contained" size="small" onClick={() => onClickSaveBillingSource()}>Pay Now</Button>
                              </Box> */}
                              </Box>
                            } />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                      {/* {
                      (billingSource !== item?.billing_source) && (
                        <Box sx={{ mr: 1 }}>
                          <Button color="primary" variant="contained" size="small" onClick={() => onClickSaveBillingSource()}>Apply</Button>
                        </Box>
                      )
                    } */}
                      <Box sx={{ mr: 1 }}>
                        <Typography variant="subtitle2" component="h6"
                          onClick={() => onClickShowVideo()}
                          style={{ cursor: 'pointer', textDecoration: 'underline', color: '#1366ff', display: 'block', paddingTop: '8px', paddingBottom: '8px' }}
                        >
                          Video
                        </Typography>
                      </Box>

                    </div>
                  </>
                ) : (<></>)
              }
            </div>

            <Box className='m-block' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: '16px' }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Balance:&nbsp;<span>{item?.credit || '0.00'}</span>&nbsp;
              </Typography>

              <Box className='m-block' sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Typography className='pe-5 py-1' id="modal-modal-title1" variant="subtitle1" component="h6">
                  Start:&nbsp;<span>{moment(item?.createdAt).format('LL')}</span>
                </Typography>

                <Typography className='pe-3 py-1' id="modal-modal-title2" variant="subtitle1" component="h6">
                  Billed on: {(logItems.length > 0) && <span>&nbsp;{item?.billed_date}</span>}
                </Typography>
              </Box>
            </Box>

            <div className="mt-3">
              <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`}>
                <Typography id="creditLogTableTitle">
                  Credit Logs
                </Typography>
                <IconButton size={`medium`} type="button" title="Export Excel" onClick={() => onClickDownloadExcel()}>
                  <DownloadIcon />
                </IconButton>
              </Stack>
            </div>

            <div className='mt-3'>
              <CreditLogsTable
                open={open}
                setOpen={setOpen}
                selectedDevice={item}
                setDevice={setItem}
                updateTimestamp={updateTimestamp}
                setUpdateTimestamp={setUpdateTimestamp}
                paypalSubscriptionDetail={paypalSubscriptionDetail}
                setPaypalSubscriptionDetail={setPaypalSubscriptionDetail}
                logItems={logItems}
                setLogItems={setLogItems}
                escrowUser={escrowUser}
                setEscrowUser={setEscrowUser}
              />
            </div>
          </Box>
        </Box>
      </Modal>
      <>
        {
          (item && item.id) ? (
            <>
              <EscrowLogsModal
                open={escrowLogsModalOpen}
                setOpen={setEscrowLogsModalOpen}
                item={item}
                setItem={setItem}
                modalType={user.administrator ? 'user' : 'self'}
              />
            </>
          ) : (<></>)
        }
      </>

      <>
        <CreditCardSelectModal
          open={cardSelectModalOpen}
          setOpen={setCardSelectModalOpen}
          onSelect={onSelectCreditCard}
          onCancel={onCancelCreditCardSelect}
          currentPaymentMethodId={item?.stripe_payment_method_id}
          currentDeviceId={item?.id}
          setParentModalOpen={setOpen}
        />
      </>

      <>
        <ConfirmDialog
          open={showConfirmModal}
          setOpen={setShowConfirmModal}
          title={APP_NAME}
          content={confirmText}
          textYes={`Agree`}
          textNo={`Cancel`}
          onClickYes={() => onClickAgreeConfirm()}
          onClickNo={() => onClickCancelConfirm()}
          maxWidth="400px"
        />
      </>
    </>
  );
};

export default PaypalCreditLogsModal;
